const fixedBottomDatePickerProps = {
  placement: 'bottomLeft',
  // Disable vertical auto-flip so the calendar stays below the input.
  builtinPlacements: {
    bottomLeft: {
      points: ['tl', 'bl'],
      offset: [0, 4],
      overflow: {
        adjustX: 1,
        adjustY: 0,
      },
    },
    bottomRight: {
      points: ['tr', 'br'],
      offset: [0, 4],
      overflow: {
        adjustX: 1,
        adjustY: 0,
      },
    },
    topLeft: {
      points: ['bl', 'tl'],
      offset: [0, -4],
      overflow: {
        adjustX: 0,
        adjustY: 0,
      },
    },
    topRight: {
      points: ['br', 'tr'],
      offset: [0, -4],
      overflow: {
        adjustX: 0,
        adjustY: 0,
      },
    },
  },
};

export default fixedBottomDatePickerProps;
